import React, { Fragment } from 'react';
import { Link } from 'library/util/core-router';
import PropTypes from 'prop-types';
import { ShimmyValue } from 'library/components/shimmy';

import 'apps/hiring/styles/sections/invalid-subscription.scss';
const OpeningsLoading = () => (
  <Fragment>
    {
      (new Array(Math.floor(Math.max(1, Math.min(1200, window.innerWidth) / 300)))).fill(null).map((v,i)=>(
        <div key={i} className="hiring-app-card hiring-app-card-loading" />
      ))
    }
  </Fragment>
);

class InvalidSubscription extends React.Component {
  render() {
    return (
      <Fragment>
        <ShimmyValue namespace="hiring-navigation-logo-text">
          <div className="subscription-cta">
            <h2 className="pairin-hiring-masthead-label">Your Subscription has Expired</h2>
            <Link to="/settings/billing/subscriptions">Re-Activate Your Account</Link>
          </div>
        </ShimmyValue>
        <ShimmyValue namespace="hiring-breadcrumbs">
          <span>Invalid Subscription</span>
        </ShimmyValue>
        <section className="hiring-app-section">
          <div className="hiring-lock">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              viewBox="0 0 502.686 502.686">
              <g fill="#d4d4d4">
                <path d="M403.676,221.014v-68.746C403.697,68.293,335.339,0,251.407,0
                      C167.411,0,99.096,68.293,99.096,152.268v68.768H66.373v281.65h369.939V221.014H403.676z M156.453,152.268
                      c0-52.309,42.581-94.825,94.933-94.825c52.266,0,94.825,42.538,94.825,94.825v68.768H156.453V152.268z M277.551,425.462h-52.266
                      l7.83-77.202c-9.664-6.018-16.178-16.76-16.178-29.077c0-18.961,15.402-34.362,34.47-34.362
                      c18.961,0,34.319,15.402,34.319,34.362c0,12.317-6.407,23.038-16.157,29.077L277.551,425.462z"
                />
              </g>
            </svg>
          </div>
          <OpeningsLoading />
        </section>
      </Fragment>
    );
  }
}

InvalidSubscription.propTypes = {
  match: PropTypes.object,
  graph_data: PropTypes.object,
  graph_loading: PropTypes.object,
  reload_graph: PropTypes.func,
  children: PropTypes.object,

};

export default InvalidSubscription;
